import type { RegisteredTenantCreateOperation } from '@festina/life-general-types/life'
import type { OperationLayerMap } from '@festina-life/api'
import { createRequiredContext } from '@festina-life/ui/libs'

import type { TemplateVersionInfo } from '../types/templateModel'
import type { EnumDefinition } from '../uiModels/enumLiterals/types'
import type { IndexedGlMapOperations } from '../uiModels/glMapOperations/types'
import type {
  IndexedParameterDefinitionCreateOperations,
  IndexedParameterValueOperations,
} from '../uiModels/parameterOperations/types'
import type { IndexedReconciliationSpecOperations } from '../uiModels/reconciliationSpecOperations/types'
import type { IndexedTemplateOperations } from '../uiModels/templateOperations/types'
import type { OperationWithSourceInfo } from '../uiModels/types'

// Indexes configuration items by tenant ID and item ID
export type ConfigurationItemsMap<T> = OperationLayerMap<Map<string, T>>

type ApplicationViewOperationsContext = {
  applicationTemplates: Map<string, IndexedTemplateOperations>
  applicationParameterDefinitions: Map<
    string,
    IndexedParameterDefinitionCreateOperations
  >
  applicationEnumDefinitions: Map<string, EnumDefinition>
  applicationGlMaps: Map<string, IndexedGlMapOperations>
  applicationReconciliationSpecs: Map<
    string,
    IndexedReconciliationSpecOperations
  >
  applicationTemplateVersionInfos: Map<string, TemplateVersionInfo[]>
  applicationParameterValues: Map<string, IndexedParameterValueOperations>
  applicationRegisteredTenants: OperationWithSourceInfo<RegisteredTenantCreateOperation>[]
}

const [useApplicationViewOperationsContext, Provider] =
  createRequiredContext<ApplicationViewOperationsContext>(
    'ApplicationViewOperations',
  )

export { Provider, useApplicationViewOperationsContext }
